import { useRef } from 'react';

import useComponentDidMount from './useComponentDidMount';

/** Как componentWillUnmount классовых компонентов. Держит свежую ссылку create. */
export default function useComponentWillUnmount(create: () => void) {
  const willUnmount = useRef<() => void>(create);

  willUnmount.current = create;

  useComponentDidMount(() => () => willUnmount.current());
}
